import { useGlobalState } from '@/hooks';
import type { ContentItemInterface } from '@/interfaces';
import { MetricItemNumber, MetricItemSubtext, MetricItemWrapper } from './Metrics.styles';

const Metrics: React.FC<ContentItemInterface> = ({ title, subTitle }) => {
  const { t } = useGlobalState();
  const translatedTitle = t(title ?? '');
  const translatedSubTitle = t(subTitle ?? '');
  return (
    <MetricItemWrapper>
      <MetricItemNumber>{translatedTitle}</MetricItemNumber>
      <MetricItemSubtext>{translatedSubTitle}</MetricItemSubtext>
    </MetricItemWrapper>
  );
};

export default Metrics;
